// Static story groups until CMS/API — mirrors wingstop-ecommerce demo structure

export const STORY_GROUPS = [
  {
    id: 'hot-deals',
    title: 'Hot Deals',
    color: '#ff6b35',
    slides: [
      {
        badge: 'LIMITED TIME OFFER',
        title: 'Wings & Tender Combo',
        subtitle: 'Limited Time Offer',
        bullets: [
          { col: ['4 Crispy Tenders', '1 Signature Dip'] },
          { col: ['5 Classic Wings', '1 Seasoned Fries'] },
        ],
        priceWas: 62,
        priceNow: 46,
        image: null,
      },
      {
        title: 'Flavor Box',
        subtitle: 'Fan favorite',
        bullets: [{ col: ['8 Wings', '1 Dip', 'Fries', 'Drink'] }],
        priceNow: 48,
        image: null,
      },
    ],
  },
  {
    id: 'signature',
    title: 'Signature Flavors',
    color: '#0e7c62',
    slides: [
      {
        title: 'Louisiana Rub',
        subtitle: 'Dry rub classic',
        bullets: [{ col: ['Bold', 'Savory'] }],
        priceNow: 0,
        image: null,
      },
    ],
  },
  {
    id: 'bestsellers',
    title: 'Bestsellers',
    color: '#6366f1',
    slides: [
      {
        title: '10 Pcs Combo',
        subtitle: '#1 Most Ordered',
        bullets: [{ col: ['Wings', 'Fries', 'Dip', 'Drink'] }],
        priceNow: 56,
        image: null,
      },
    ],
  },
  {
    id: 'rewards',
    title: 'Wing Rewards',
    color: '#ec4899',
    slides: [{ title: 'Earn points on every order', subtitle: 'Join rewards', bullets: [], priceNow: 0, image: null }],
  },
  {
    id: 'house-party',
    title: 'House Party',
    color: '#14b8a6',
    slides: [{ title: 'Feed the crew', subtitle: 'Group bundles', bullets: [], priceNow: 0, image: null }],
  },
  {
    id: 'about',
    title: 'About Wingstop',
    color: '#a67c52',
    slides: [{ title: 'Our story', subtitle: 'Flavor. Done right.', bullets: [], priceNow: 0, image: null }],
  },
];

export const STORY_TILES = [
  { id: 'hot-deals', label: 'Hot Deals', gradient: 'linear-gradient(135deg, #ff8c42 0%, #ff6b35 100%)' },
  { id: 'signature', label: 'Signature Flavors', gradient: `linear-gradient(135deg, #065f4a 0%, #0e7c62 100%)` },
  { id: 'bestsellers', label: 'Bestsellers', gradient: 'linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)' },
  { id: 'rewards', label: 'Wing Rewards', gradient: 'linear-gradient(135deg, #ff7eb3 0%, #ec4899 100%)' },
  { id: 'house-party', label: 'House Party', gradient: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)' },
  { id: 'about', label: 'About Wingstop', gradient: 'linear-gradient(135deg, #d4a574 0%, #a67c52 100%)' },
];
